import { createDialogContextBundle } from "src/components/Dialog";
import { DeleteDraftDialogProps } from "./types";

export const {
  DialogContext: DeleteDraftDialogContext,
  useDialogContext: useDeleteDraftDialogContext,
} = createDialogContextBundle<DeleteDraftDialogProps>();
